import dayjs, { Dayjs } from 'dayjs';
import { toInteger } from 'lodash';

import { PermissionType } from '../../types/common';
import { getColorKeyFromCourse, getShortNameFromCourse } from '../../utils/common/courses';
import { Course } from '../courses/types';
import { BaseTutorial } from '../students/types';

import { Tutorial } from './types';

export const getStartDatetime = (startDatetimeIdentifier: string): Dayjs =>
  dayjs(toInteger(startDatetimeIdentifier.split('#')[0]));

export const getBaseAttributes = (tutorial: Tutorial | BaseTutorial, courses: Course[]) => ({
  id: tutorial.startDatetimeIdentifier,
  startDatetime: getStartDatetime(tutorial.startDatetimeIdentifier).valueOf(),
  details: {
    duration: tutorial.duration,
    title: `${getShortNameFromCourse(tutorial.course, courses) ?? 'Unknown'} Tutorial`,
    color: getColorKeyFromCourse(tutorial.course, courses),
  },
});

export const getPermissionsForCourse = (course: string): string[] => {
  const tags: string[] = [PermissionType.Base, PermissionType.Tutorial];

  // Append the subject part of course string
  tags.push(course.slice(0, 4).toUpperCase());

  // Append the year part of the course string
  tags.push(course.slice(4, 6).toUpperCase());

  const permissions: string[] = [];

  for (let i = 0; i < tags.length; i++) {
    permissions.push(tags.slice(0, i + 1).join('_'));
  }

  return permissions;
};

// Get array of courses based on permissions
export const getCoursesFromPermissions =
(permissions: string[], courses: Course[]) =>
  courses?.filter((c) => permissions.some((p) => getPermissionsForCourse(c.id).includes(p)));

// Determine whether the permissions array includes a tutorial permission
export const hasTutorialPermissions = (permissions: string[]): boolean =>
  permissions.some((p) => p === PermissionType.Base || p.startsWith(`${PermissionType.Base}_${PermissionType.Tutorial}`));
